// extracted by mini-css-extract-plugin
module.exports = {"hide":"withStoreHeader_hide__2jBgU","show":"withStoreHeader_show__2GuVf"};